module.exports = __webpack_public_path__ + "img/Search.a970ff6e.svg";